import React, { useContext, useEffect, useState, useMemo, Fragment, createContext } from 'react';
import { useParams } from 'react-router';
import { Footer } from '../../Component/Footer/Footer';
import { Header } from '../../Component/Header/Header';
import { Recommend } from '../../Component/Recommend/Recommend';
import { ARROW_STYLE, POINT_STYLE, Swiper } from '../../Component/Swiper/Swiper';
import { fetchData } from '../../Utils/fetch';
import { imageDomain, STYLE_TYPE } from '../../Utils/magicStrings';
import { styleContextApp } from '../StyleContext';
import { ReserveWrapper, Line, LeftPartWrapper, LeftTitle,
    BenefitItemWrapper, BenefitWrapper, BenefitItemContent, BenefitItemTitle, LeftIntroText, 
    PlanItemWrapper, PlanWrapper, ReserveTeleWrapper,
    MemoWrapper, MainPart,ReservePictureWrapper,
    PlanPicture, PlanButton, PlanName, PlanPrice,
    RightPartWrapper, ChoiceWrapper, ChoiceLogo,
    ChoiceText, ChoiceArrow, ChoiceMainWrapper,
    PlusButton, MinusButton, ChoiceItemText,
    ChoiceItemWrapper, ButtonWrapper, ClearButton,ConfirmButton, Shadow, CloseButton, ErrorNotice, WechatWindow
    } from './ReserveStyle';
import people from './people.png';
import room from './room.png';
import up from './up.png';
import down from './down.png';
import plus from './plus.png';
import minus from './minus.png';
import closeWhite from './closeWhite.png';
import closepic from './close.png';
import calendar from './calendar.png';
import { Toptips } from '../Home/HomeStyle';
import { DatePicker } from '@arco-design/web-react';
import '@arco-design/web-react/dist/css/arco.css';
import { ReserveModal } from './ReserveModal';
import { px2vw } from '../../Utils/common';
import { Modal } from '../../Component/Modal/Modal';
import wechat from './wechat.png';
import { useLocation } from 'react-router-dom';


export const Reserve = () => {
    const { id } = useParams();
    const location  = useLocation();
    const [ content, setContent ] = useState(null);
    const [ peopleNumber, setPeopleNumber ] = useState((location && location.state?.peopleNumber) || [0,0]);
    const [ roomNumber, setRoomNumber ] = useState((location && location.state?.roomNumber) || null);
    const [ reserveDate, setReserveDate ] = useState((location && location.state?.reserveDate )|| ['','']);
    const [ checkError, setCheckError ] = useState(false);
    const [ plan, setPlan ] = useState((location &&  location.state?.plan) || -1);
    const [ showTips, setShowTips ] = useState(checkEmpty(roomNumber) || checkEmpty(peopleNumber) || checkEmpty(reserveDate));
    const styleType = useContext(styleContextApp);
    const [ showReserveModal, setShowReserveModal ] = useState((location && location.state?.name));
    const [ height, setHeight ] = useState(1274);
    useEffect(() => {
        if(id) {
            getContentInfo(id);
        }
    }, [id]);

    useEffect(() => {
        setShowTips(checkEmpty(roomNumber) || checkEmpty(peopleNumber) || checkEmpty(reserveDate))
    }, [roomNumber, peopleNumber, reserveDate]);


    const getContentInfo = async (id) => {
        
        if(id) {
            try {
                const data = await fetchData(`inn/${id}`);
                setContent(data);
            } catch(e) {
                console.log(e);
            }
        } 
    };

    // const left = document.getElementById('left');
    // const tempHeight = styleType !== STYLE_TYPE.MOBILE && left ? left.getBoundingClientRect().height : 1274;

    // useEffect(() => {
    //     setHeight(tempHeight);
    // }, [tempHeight])


    if(!content) return null;

    return (
        <ReserveWrapper>
            <Header title={`${content.title}-${content.name}`} styleType={styleType} pictures={[`${imageDomain}/${content.coverImgUrl}`]} hasMarginTop={false} headerHeight={584} mobileHeight={404}/>
            
            {
                showTips && checkError && 
                <Toptips id='toptip' styleType={styleType} color={'#BA5B5B'}>
                    <span>您有未填選項</span>
                    <img id='close' src={closeWhite} alt='' onClick={() => setShowTips(false)}></img>
                </Toptips>
            }
            {styleType !== STYLE_TYPE.MOBILE && (<MainPart styleType={styleType}>
                <LeftWrapper styleType={styleType} content={content} peopleNumber={peopleNumber} roomNumber={roomNumber} reserveDate={reserveDate} setCheckError={setCheckError} setShowReserveModal={setShowReserveModal} setPlan={setPlan}></LeftWrapper>
                <RightPartWrapper styleType={styleType}>
                    <PeopleNumberSelection styleType={styleType} peopleNumber={peopleNumber} setPeopleNumber={setPeopleNumber} checkError={checkError}/>
                    <RoomNumberSelection styleType={styleType} setRoomNumber={setRoomNumber} roomNumber={roomNumber} roomText={content.roomTypeList || roomText} checkError={checkError}/>
                    <CalendarSelection styleType={styleType} reserveDate={reserveDate} setReserveDate={setReserveDate} checkError={checkError}/>
                </RightPartWrapper>
            </MainPart>)}
            {styleType === STYLE_TYPE.MOBILE && (
                <MainPart styleType={styleType}>
                    <LeftTitle styleType={styleType}>{`${content.name}`}</LeftTitle>
                    <ReservePicture styleType={styleType} content={content} />
                    <Benefit styleType={styleType} content={content}/>
                    <PeopleNumberSelection styleType={styleType} peopleNumber={peopleNumber} setPeopleNumber={setPeopleNumber} checkError={checkError}/>
                    <RoomNumberSelection styleType={styleType} setRoomNumber={setRoomNumber} roomNumber={roomNumber} roomText={content.roomTypeList || roomText} checkError={checkError}/>
                    <CalendarSelection styleType={styleType} reserveDate={reserveDate} setReserveDate={setReserveDate} checkError={checkError}/>
                    <Plan setShowReserveModal={setShowReserveModal}  setPlan={setPlan} styleType={styleType} content={content} peopleNumber={peopleNumber} roomNumber={roomNumber} reserveDate={reserveDate} setCheckError={setCheckError}/>
                    <ReserveInfo styleType={styleType} content={content}/>
                </MainPart>
            )}
            <div style={{width: 'min(1440px, 100vw)', margin: 'auto'}}>
            <Recommend styleType={styleType} recommendItem={content.recommendList} />
            </div>
            <Footer styleType={styleType}></Footer>
            {showReserveModal && <ReserveModal content={content} coverImgUrl={`${imageDomain}/${content.coverImgUrl}`} plan={plan} peopleNumber={peopleNumber} setShowReserveModal={setShowReserveModal} reserveDate={reserveDate} roomNumber={roomNumber} 
                wechat={(location && location.state?.wechat) || ''}
                line={(location && location.state?.line) || ''}
                tele={(location && location.state?.tele) || ''}
                name={(location && location.state?.name) || ''}
                email={(location && location.state?.email) || ''}
                innId={id}
                />}
        </ReserveWrapper>
    );
};

const LeftWrapper = ({styleType, content, isDone, setCheckError, peopleNumber, roomNumber, reserveDate,  setShowReserveModal, setPlan}) => {
    return (
        <LeftPartWrapper id={'left'} styleType={styleType}>
            <LeftTitle styleType={styleType}>{`${content.title}-${content.name}`}</LeftTitle>
            <ReservePicture styleType={styleType} content={content}/>
            <Benefit styleType={styleType} content={content}/>
            <Plan setShowReserveModal={setShowReserveModal}  setPlan={setPlan} styleType={styleType} content={content} isDone={isDone} peopleNumber={peopleNumber} roomNumber={roomNumber} reserveDate={reserveDate} setCheckError={setCheckError} />
            <ReserveInfo styleType={styleType} content={content}/>
        </LeftPartWrapper>
    );
};

const ReservePicture = ({styleType,content }) => {
    const pictures = content?.innSectionDtoList?.reduce((last, info) => {
        return info.imgUrlList ? last.concat(info.imgUrlList) : last;
    }, []);

    const swiperElement = pictures.map((pic, index) => (
        <img data-src={`${imageDomain}/${pic}`} key={index} alt='' className='lazyload' style={{width: '100%', height: '100%'}} />
    ));
    return (
        <ReservePictureWrapper styleType={styleType}>
            <Swiper
                height={styleType === STYLE_TYPE.MOBILE ? 230 : 295} 
                        isAutoPlay={false} 
                        pointStyle={POINT_STYLE.NONE} 
                        arrowStyle={styleType === STYLE_TYPE.MOBILE ? ARROW_STYLE.WHITE_CIRCLE_2 :ARROW_STYLE.BIG_CIRCLE_2}  
                        elements={swiperElement} 
                        isLoop={true} 
                        arrowPositionLeft={{
                            top: '50%',
                            transform: 'translate(0, -50%)',
                            left: '0.7vw',
                        }}
                        arrowPositionRight={{
                            top: '50%',
                            transform: 'translate(0, -50%)',
                            right: '0.7vw',
                        }}
            />
        </ReservePictureWrapper>
    )
}

const Benefit = ({styleType, content}) => {
    return (
        <BenefitWrapper styleType={styleType}>
            {content.innExtraList.map((extra) => {
                return (<BenefitItem key={extra.title} styleType={styleType} extra={extra}/>)
            })}
        </BenefitWrapper>
    );
}

const Plan = ({styleType, content, setCheckError, roomNumber, peopleNumber, reserveDate, setShowReserveModal, setPlan}) => {
    return (
        <Fragment>
            <LeftIntroText styleType={styleType}>請先選擇<b>人數</b>與<b>房間數</b>，<b>入住日期</b>再選擇您中意的套餐。</LeftIntroText>
            <PlanWrapper styleType={styleType}>
                {
                    content?.innPlanList.map((plan, index) => (
                        <PlanItem styleType={styleType} key={plan.title} plan={plan} setPlan={setPlan} setCheckError={setCheckError} roomNumber={roomNumber} peopleNumber={peopleNumber} reserveDate={reserveDate} setShowReserveModal={setShowReserveModal}/>
                    ))
                }
            </PlanWrapper>
        </Fragment>
    )
}

const ReserveInfo = ({styleType, content}) => {
    const [showWechat, setShowWechat] = useState(false);
    const toShowWechat = () => {
        setShowWechat(true);
    }
    const wechatElement = useMemo(() => {
        return (
            <WechatWindow styleType={styleType} setShowMenu={setShowWechat} >
                <img src={wechat} alt=''></img>
            </WechatWindow>
        )
    }, [styleType]); 
    return ( 
        <Fragment>
            <ReserveTeleWrapper styleType={styleType}>
                <span>如有疑問請諮詢</span>
                <a href='https://www.facebook.com/megurutraveljp/'>FB</a>
                <span>或是</span>
                <span onClick={toShowWechat} style={{color: 'rgb(85, 26, 139)',
                cursor: 'pointer'}}>微信</span>
            </ReserveTeleWrapper>
            <MemoWrapper styleType={styleType}>
            这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位
            </MemoWrapper>
            {showWechat && <Modal positionType={'middle'} modalElement={wechatElement} setModalOpen={setShowWechat} backdropClose={true}/>}
        </Fragment>
    )
}


const PeopleNumberSelection = ({styleType, setPeopleNumber, peopleNumber, checkError}) => {
    const [ isExtended, setIsExtended ] = useState(false);
    const [ peopleNumberTemp, setPeopleNumberTemp ] = useState(peopleNumber || [0,0]);
    const showNotice = checkError && checkEmpty(peopleNumber);
    return (
        <Fragment>
            {showNotice && 
            <ErrorNotice styleType={styleType}>
                <div id='dot'/><div id='text'>請選擇入住人數</div>
            </ErrorNotice>}
            <ChoiceWrapper styleType={styleType}  type={'people'} onClick={() => {setIsExtended(e => !e)}}>
                <ChoiceLogo styleType={styleType} type={'people'}>
                    <img src={people} alt=''/>
                </ChoiceLogo>
                <ChoiceText styleType={styleType} type={'people'} color={checkEmpty(peopleNumber) ? 'black' : 'white'}>
                    {checkEmpty(peopleNumber) ? '選擇您的入住人數' : `${peopleNumber[0]}位大人${peopleNumber[1]}位小孩`}
                </ChoiceText>
                <ChoiceArrow styleType={styleType} type={'people'}>
                    <img src={isExtended ? up : down} alt=''/>
                </ChoiceArrow>
            </ChoiceWrapper>
            { isExtended && styleType === STYLE_TYPE.MOBILE && <Shadow/>}
            { isExtended && 
                (<ChoiceMainWrapper styleType={styleType}>
                    {styleType === STYLE_TYPE.MOBILE && (
                            <CloseButton  styleType={styleType}>
                                <img onClick={() => {
                                    setPeopleNumber(peopleNumberTemp);
                                    setIsExtended(e => !e)
                            }} src={closepic} alt='' />
                            </CloseButton>
                    )}
                    {
                        ['位大人', '位小孩'].map((text, index) => (
                            <ChoiceItem
                                styleType={styleType}
                                index={index}
                                text={text}
                                setMethod={setPeopleNumberTemp}
                                nowState={peopleNumberTemp}
                                type={'people'}
                                key={text}
                            ></ChoiceItem>
                        ))
                    }
                    <ButtonWrapper styleType={styleType}>
                        {styleType !== STYLE_TYPE.MOBILE && (
                            <Fragment>
                                <ClearButton 
                                    styleType={styleType}
                                    onClick={() => {
                                        setPeopleNumberTemp([0,0]);
                                        setPeopleNumber([0,0]);
                                    }}
                                >清除</ClearButton>
                                <ConfirmButton 
                                    styleType={styleType}
                                    onClick={() => {
                                        setPeopleNumber(peopleNumberTemp);
                                        setIsExtended(e => !e)
                                    }}
                                >確認</ConfirmButton>
                            </Fragment>)}
                        {styleType === STYLE_TYPE.MOBILE && (
                            <div style={{width: '100%', textAlign: 'center', fontSize: px2vw(14, 375)}}onClick={() => {
                                setPeopleNumber(peopleNumberTemp);
                                setIsExtended(e => !e)
                            }}>選擇您的入住人數</div>
                        )}
                    </ButtonWrapper>
                </ChoiceMainWrapper>
            )}
        </Fragment>
    );
};

const RoomNumberSelection = ({styleType, setRoomNumber, roomNumber, roomText, setCheckError, checkError}) => {
    const [ isExtended, setIsExtended ] = useState(false);
    const [ roomNumberTemp, setRoomNumberTemp ] = useState(roomNumber || new Array(roomText.length).fill(0));
    const showNotice = checkError && checkEmpty(roomNumber || []);
    
    return (
        <Fragment>
            {showNotice && 
            <ErrorNotice styleType={styleType}>
                <div id='dot'/><div id='text'>請選擇需要的房間數</div>
            </ErrorNotice>}
            <ChoiceWrapper styleType={styleType} type={'room'} onClick={() => {setIsExtended(e => !e)}}>
                <ChoiceLogo styleType={styleType} type={'room'}>
                    <img src={room} alt=''/>
                </ChoiceLogo>
                <ChoiceText styleType={styleType} type={'room'} color={checkEmpty(roomNumber || []) ? 'black' : 'white'}>
                    {checkEmpty(roomNumber || []) ? '選擇您需要的房間數' : '已選擇房間數'}
                </ChoiceText>
                <ChoiceArrow styleType={styleType} type={'room'}>
                    <img src={isExtended ? up : down} alt=''/>
                </ChoiceArrow>
            </ChoiceWrapper>
            { isExtended && styleType === STYLE_TYPE.MOBILE && <Shadow/>}
            { isExtended && 
                <ChoiceMainWrapper styleType={styleType}>
                    {styleType === STYLE_TYPE.MOBILE && (
                            <CloseButton  styleType={styleType}>
                                <img onClick={() => {
                                    setRoomNumber(roomNumberTemp);
                                    setIsExtended(e => !e)
                            }} src={closepic} alt='' />
                            </CloseButton>
                    )}
                    {
                        roomText.map((text, index) => (
                            <ChoiceItem
                                styleType={styleType}
                                index={index}
                                text={text}
                                checkError={checkError}
                                setCheckError={setCheckError}
                                setMethod={setRoomNumberTemp}
                                nowState={roomNumberTemp}
                                type={'room'}
                                key={text}
                            ></ChoiceItem>
                        ))
                    }
                    <ButtonWrapper styleType={styleType}>
                        {styleType !== STYLE_TYPE.MOBILE && (<Fragment><ClearButton 
                            styleType={styleType}
                            onClick={() => {
                                setRoomNumberTemp([0,0]);
                                setRoomNumber([0,0]);
                            }}
                        >清除</ClearButton>
                        <ConfirmButton 
                            styleType={styleType}
                            onClick={() => {
                                setRoomNumber(roomNumberTemp);
                                setIsExtended(e => !e);
                            }}
                        >確認</ConfirmButton></Fragment>)}

                        {styleType === STYLE_TYPE.MOBILE && (
                            <div style={{width: '100%', textAlign: 'center', fontSize: px2vw(14, 375)}}onClick={() => {
                                setRoomNumber(roomNumberTemp);
                                setIsExtended(e => !e);
                            }}>選擇您需要的房間數</div>
                        )}
                    </ButtonWrapper>
                </ChoiceMainWrapper>
            }
        </Fragment>
    );
};

const CalendarSelection = ({styleType, setReserveDate, reserveDate, setCheckError, checkError}) => {
    const [ isExtended, setIsExtended ] = useState(false);
    const [ reserveDateTemp, setReserveDateTemp ] = useState(reserveDate);
    const [ showNotice, setShowNotice ] = useState(checkError && checkEmpty(reserveDate));
    const [ noticeText, setNoticeText ] = useState('選擇您的希望入住日期');
    return (
        <Fragment>
            {showNotice && 
            <ErrorNotice styleType={styleType}>
                <div id='dot'/><div id='text'>{noticeText}</div>
            </ErrorNotice>}
            <ChoiceWrapper styleType={styleType} type={'calendar'} onClick={() => {setIsExtended(e => !e)}}>
                <ChoiceLogo styleType={styleType} type={'calendar'}>
                    <img src={calendar} alt=''/>
                </ChoiceLogo>
                <ChoiceText styleType={styleType} type={'calendar'} color={checkEmpty(reserveDate) ? 'black' : 'white'}>
                    {checkEmpty(reserveDate) ? '選擇您的希望入住日期' : `${reserveDate[0]}~${reserveDate[1]}`} 
                </ChoiceText>
                <ChoiceArrow styleType={styleType} type={'calendar'}>
                    <img src={isExtended ? up : down} alt=''/>
                </ChoiceArrow>
            </ChoiceWrapper>
            { isExtended && styleType === STYLE_TYPE.MOBILE && <Shadow/>}
            { isExtended && 
                <ChoiceMainWrapper styleType={styleType}>
                    {styleType === STYLE_TYPE.MOBILE && (
                            <CloseButton  styleType={styleType}>
                                <img onClick={() => {
                                    setReserveDate(reserveDateTemp);
                                    setIsExtended(e => !e)
                            }} src={closepic} alt='' />
                            </CloseButton>
                    )}
                    <CalendarItem styleType={styleType} text={'入住日期'} index={0} setDate={setReserveDateTemp} nowState={reserveDateTemp}/>
                    <CalendarItem styleType={styleType} text={'離開日期'} index={1} setDate={setReserveDateTemp} nowState={reserveDateTemp}/>
                    <ButtonWrapper styleType={styleType}>
                        {styleType !== STYLE_TYPE.MOBILE && (<Fragment>
                            <ClearButton 
                            styleType={styleType}
                            onClick={() => {
                                setIsExtended(e => !e);
                                setReserveDateTemp(['','']);
                                setReserveDate(['','']);
                            }}
                        >清除</ClearButton>
                        <ConfirmButton 
                            styleType={styleType}
                            onClick={() => {
                                if(reserveDateTemp[0] > reserveDateTemp[1]) {
                                    setShowNotice(true);
                                    setNoticeText('離開日期應當晚於入住日期');
                                } else {
                                    setShowNotice(false);
                                    setNoticeText('選擇您的希望入住日期');
                                    setReserveDate(reserveDateTemp);
                                    setIsExtended(e => !e);
                                }
                            }}
                        >确认</ConfirmButton></Fragment>)}

                        {styleType === STYLE_TYPE.MOBILE && (
                            <div style={{width: '100%', textAlign: 'center', fontSize: px2vw(14, 375)}}onClick={() => {
                                if(reserveDateTemp[0] > reserveDateTemp[1]) {
                                    setShowNotice(true);
                                    setNoticeText('離開日期應當晚於入住日期');
                                } else {
                                    setShowNotice(false);
                                    setNoticeText('選擇您的希望入住日期');
                                    setReserveDate(reserveDateTemp);
                                    setIsExtended(e => !e);
                                }
                            }}>選擇您的希望入住日期</div>
                        )}
                    </ButtonWrapper>
                </ChoiceMainWrapper>
            }
        </Fragment>
    );
};


const ChoiceItem = ({styleType, index, setMethod, nowState, text, type}) => {
    const setTempNumer = (method, index, setMethod) => {
        setMethod(e => {
            const newState = Array.from(e);
            if(newState[index] === 0  && method === 'm') return newState;
            if(method === 'm' && newState[index] !== 0) {
                newState[index] -= 1;
            } else if(method === 'p') {
                newState[index] += 1;
            }
            return newState;
        });
    };
    return (
        <ChoiceItemWrapper styleType={styleType}>
            <MinusButton styleType={styleType}  type={type} onClick={() => setTempNumer('m', index, setMethod)}>
                <img src={minus} alt=''/>
            </MinusButton>
            <ChoiceItemText styleType={styleType} type={type}>
                {nowState[index]}{text}
            </ChoiceItemText>
            <PlusButton styleType={styleType} type={type}  onClick={() => setTempNumer('p', index, setMethod)}>
                <img src={plus} alt=''/>
            </PlusButton>
        </ChoiceItemWrapper>
    )
}

const CalendarItem = ({styleType, index, setDate, nowState,text='入住日期'}) => {
    const setCallback = (e) => {
        setDate(state => {
            const newState = Array.from(state);
            newState[index] = e;
            return newState;
        })
    }

    function disabledDate(current) {
        // Can not select days before today
        return current && current < new Date() - 86400000;
    }

    return (
        <ChoiceItemWrapper styleType={styleType}>
            <ChoiceItemText styleType={styleType}>
                {text}
            </ChoiceItemText>
            <DatePicker disabledDate={disabledDate} style={{ width: styleType === STYLE_TYPE.MOBILE ?  '55vw' : '15.5vw' }} defaultValue={nowState[index] || ''} editable={false} onSelect={setCallback} />
        </ChoiceItemWrapper>
    )
}

const BenefitItem = ({styleType, extra}) => {
    return(
        <BenefitItemWrapper styleType={styleType}>
            <BenefitItemTitle styleType={styleType}>
                <div id='dot'/>
                <div id='text'>{extra.title}</div>
            </BenefitItemTitle>
            <BenefitItemContent styleType={styleType}>
                {extra.content}
            </BenefitItemContent>
        </BenefitItemWrapper>
    );
};

const PlanItem = ({styleType, plan, peopleNumber, roomNumber, reserveDate, setCheckError, setShowReserveModal, setPlan}) => {
    
    const clickToReserve = (e) => {
        if(checkEmpty(peopleNumber) || checkEmpty(roomNumber) || checkEmpty(reserveDate)) {
            setCheckError(true);
        } else {
            setShowReserveModal(true);
            setPlan(plan);
        }
    }

    return(
        <PlanItemWrapper styleType={styleType}>
            <PlanPicture  styleType={styleType}>
                <img data-src={`${imageDomain}/${plan.imgUrl}`} className='lazyload' alt=''/>
            </PlanPicture>
            <PlanName styleType={styleType}>{plan.title}</PlanName>
            {plan.priceFrom && <PlanPrice styleType={styleType}> ¥{plan.priceFrom}日圓起～</PlanPrice>}
            <PlanButton styleType={styleType} onClick={clickToReserve}>現在預定</PlanButton>
        </PlanItemWrapper>
    )
};


const checkEmpty = (arr) => {
    return arr && arr.filter(e => e!==0 && e).length === 0;
}

  const roomText = ['和室(榻榻米)', '洋室(大床)', '洋室(双床)'];